<template>
  <div class="wrap-container">
    <Header page="index"></Header>
    <!-- <keep-alive :include="cachedViews"> -->
    <router-view :key="key" />
    <!-- </keep-alive> -->
    <Footer page="index" v-if="!$route.meta.isFoot" />
    <Contact></Contact>
  </div>
</template>

<script>
import Contact from "../../components/Contact.vue";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { delayDither } from "@/utils/index.js";
const $delayDither = delayDither(600);
export default {
  // 建议 创建每个组件时 都添加name属性 标识组件名称
  name: "AppMain",
  components: {
    Header,
    Footer,
    Contact,
  },
  data () {
    return {};
  },
  // 计算属性 适配者模式
  computed: {
    cachedViews () {
      return this.$store.state.keepAlive.cachedViews;
    },
    key () {
      return this.$route.path;
    },
  },
  // 数据监听
  watch: {},

  /**
   * 生命周期 类似 发布订阅者模式
   */

  /** 被keep-alive 缓存的页面
   * keep-alive
   * 页面第一次进入的时候，
   * 钩子触发的顺序是created->mounted->activated
   */
  activated () { },
  /** 被keep-alive 缓存的页面
   * 页面退出的时候会触发deactivated，
   * 当再次前进或者后退的时候只触发activated
   */
  deactivated () { },
  // 组件实例初始化完成之后
  beforeCreate () { },
  // 组件实例处理完所有与状态相关的选项
  created () { },
  // 组件被挂载之前
  beforeMount () { },
  // 组件被挂载之后
  mounted () { },
  // 组件即将因为一个响应式状态变更而更新其 DOM 树之前调用
  beforeUpdate () { },
  // 组件因为一个响应式状态变更而更新其 DOM 树之后调用
  updated () { },
  // 在一个组件实例被卸载之前调用。
  beforeUnmount () { },
  beforeDestroy () { },
  destroyed () { },
  methods: {
    /**
     *  页面点击事件 防抖
     * @param {Object} ev  $event
     * @param {String} name 执行名称
     * @param {Object} data 传值
     */
    onClickOperate (ev, name, data = {}) {
      $delayDither(() => {
        switch (name) {
          case "btn1":
            console.log(data.name);
            break;
          case "btn2":
            console.log(data.name);
            break;
          case "btn3":
            console.log(data.name);
            break;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap-container {
  position: relative;
  box-sizing: border-box;
  width: 100vw;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.fixed-btn {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 5;
}
</style>
